import Cookies from 'universal-cookie'

const cookies = new Cookies()

export function setCookie(cookieName: string, value: string, expiresAt?: number): void {
  cookies.set(cookieName, value, {
    path: '/',
    expires: expiresAt ? new Date(expiresAt * 1000) : undefined,
    sameSite: 'none' /* to set cookies when the app is opened in different domain (extension configuration)*/,
    secure: true /* to set cookies when the app is opened in different domain (extension configuration)*/,
  })
}

export function getCookie(cookieName: string): unknown {
  return cookies.get(cookieName)
}

export function removeCookie(CookieName: string): void {
  cookies.remove(CookieName, { path: '/', secure: true, sameSite: 'none' })
}
